import React from 'react';
import { Button, Chip } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FormattedMessage } from 'react-intl';
import { TranslationKeys } from '../../../../../translations';
import type { AdminFeature } from '../constants';
import {
  FeatureCardStyled,
  CardTopBandStyled,
  CardIconCircleStyled,
  CardBodyStyled,
  CardTitleStyled,
  CardDescriptionStyled,
  CardFooterStyled,
} from '../AdminPanelManagementPage.styles';

type FeatureCardProps = {
  feature: AdminFeature;
  color: string;
  onNavigate: (link: string) => void;
};

export const FeatureCard = ({ feature, color, onNavigate }: FeatureCardProps) => {
  const available = !feature.comingSoon;

  return (
    <FeatureCardStyled
      elevation={0}
      available={available}
      onClick={available ? () => onNavigate(feature.link) : undefined}
    >
      <CardTopBandStyled bandcolor={color}>
        <CardIconCircleStyled bandcolor={color}>
          <FontAwesomeIcon icon={feature.icon} />
        </CardIconCircleStyled>
        {feature.comingSoon && (
          <Chip
            label={<FormattedMessage id={TranslationKeys.adminPanel_comingSoon} />}
            size="small"
            sx={{
              backgroundColor: `${color}22`,
              color,
              fontWeight: 700,
              fontSize: '0.65rem',
              height: 22,
              letterSpacing: '0.03em',
            }}
          />
        )}
      </CardTopBandStyled>

      <CardBodyStyled>
        <CardTitleStyled variant="body1">
          <FormattedMessage id={feature.titleId} />
        </CardTitleStyled>
        <CardDescriptionStyled variant="body2">
          <FormattedMessage id={feature.descriptionId} />
        </CardDescriptionStyled>
      </CardBodyStyled>

      <CardFooterStyled>
        {available ? (
          <Button
            size="small"
            variant="text"
            endIcon={<FontAwesomeIcon icon={faArrowRight} />}
            sx={{ color, fontWeight: 600 }}
          >
            <FormattedMessage id={TranslationKeys.adminPanel_open} />
          </Button>
        ) : (
          <Button size="small" variant="text" disabled sx={{ fontSize: '0.75rem' }}>
            <FormattedMessage id={TranslationKeys.adminPanel_comingSoon} />
          </Button>
        )}
      </CardFooterStyled>
    </FeatureCardStyled>
  );
};
